export function calculateWidth(videoWidth, videoHeight, baseHeight) {
  if (videoWidth === 0) {
    return 0;
  }
  return Math.ceil((videoWidth / videoHeight) * baseHeight);
}

export function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

  return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export function getSpreadNoOfImageUrlsFromList(NoImages, urlImageList) {
  const len = urlImageList.length;
  const imagesLimitedList = [];
  const step = Math.floor(len / NoImages);
  let i = 0;
  let NoImagesAdded = 0;
  let url;

  for (i; i < len; i += step) {
    if (NoImagesAdded == NoImages - 1) {
      url = urlImageList[len - 1];
    } else {
      url = urlImageList[i];
    }

    if (url) {
      imagesLimitedList.push(url);
    }

    if (NoImagesAdded == NoImages - 1) {
      break;
    }
    NoImagesAdded++;
  }
  return imagesLimitedList;
}

export function durationFormat(s) {
  let m = Math.floor(s / 60);
  m = (m >= 10) ? m : `0${m}`;
  s = Math.floor(s % 60);
  s = (s >= 10) ? s : `0${s}`;
  return `${m}:${s}`;
}
